import { startSessionRecordingPostHog, isSessionRecordingActivePostHog } from "@/lib/posthogAnalytics";
import { useEffect } from "react";

const RETRY_MS = [0, 1500, 4000, 10000];

/**
 * Session replay obligatorio para TODOS los visitantes (anónimos + Clerk).
 * No depende de cookie consent ni de identify — el worker remoto de PostHog
 * puede tardar; reintentamos hasta que el recorder arranque.
 */
export function SessionRecordingEnforcer() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const ensure = () => {
      if (!isSessionRecordingActivePostHog()) {
        startSessionRecordingPostHog();
      }
    };

    const timers = RETRY_MS.map((ms) => window.setTimeout(ensure, ms));

    const onVisible = () => {
      if (document.visibilityState === "visible") ensure();
    };
    document.addEventListener("visibilitychange", onVisible);

    const interval = window.setInterval(ensure, 30_000);

    return () => {
      timers.forEach((t) => window.clearTimeout(t));
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
}